<template>
  <section :class="$style.root" :id="data?.id">
    <h1 :class="$style.heading">
      {{ data?.educationPageEntries?.length > 1 ? data?.title : data?.titleSingular || data?.title }}
    </h1>

    <core-truncated-text-component
      v-if="data?.richText?.richText"
      :class="$style.introduction"
      :rich-text="data?.richText?.richText"
      :rich-text-truncated="data?.richText?.richTextTruncated"
    />

    <shared-education-categories-group-images-component
      :data="data"
      :on-edition-page="onEditionPage"
      :class="$style.carouselContainer"
    />

    <ul
      v-if="educationPageEntries?.length"
      :class="$style.list"
    >
      <li
        v-for="(item, index) in educationPageEntries"
        :key="item?.id || index"
        :class="$style.item"
      >
        <shared-education-categories-group-thumbnail-component
          :data="item"
          :on-edition-page="onEditionPage"
        />
      </li>
    </ul>
  </section>
</template>

<script lang="ts" setup>
import { orderBy } from 'lodash-es'
const nuxtApp = useNuxtApp()

const props = defineProps({
  data: Object,
  onEditionPage: {
    type: Boolean,
    default: false
  }
})

const educationPageEntries = computed(() => {
  return orderBy(props.data?.educationPageEntries, (i) => {
    return [i?.biennialEntry?.editionIndex, i?.title?.toLowerCase()]
  }, ['desc', 'asc'])
})
</script>

<style module lang="scss">
.root {
}

.heading {
  composes: reset-heading font-size-medium from global;
  margin-bottom: calc(var(--font-small--line-height) * 1);
  color: var(--color--secondary);
}

.introduction {
  composes: font-size-default from global;

  margin-bottom: var(--font-small--line-height);
}

.introduction:has(button) {
  margin-bottom: calc(var(--font-small--line-height) + (var(--font-small--line-height) - var(--compensation--lh)));
}

.introduction[data-inline] * {
  display: inline;
}

.carouselContainer {
  display: flex;
  justify-content: center;
  flex-direction: column;

  margin-bottom: var(--font-small--line-height);
}

.carousel {
  width: 100%;
}

.list {
  composes: reset-list from global;

  margin-top: var(--font-small--line-height);

  columns: 2;
  gap: var(--stroke--default);

  @media (max-width: $breakpoint-xs) {
    column-count: 1;
  }
}

.item {
  break-inside: avoid;
  padding-bottom: var(--stroke--default);
}
</style>
